<template>
    <div class="bg">
        <div class="workPlatPage" @click="handleClick">
            <el-carousel>
                <el-carousel-item v-for="(list, index) in realMenuLists" :key="index">
                    <div class="workPlatPageBox">
                        <ul>
                        <!-- <li
                            v-for="(item, index) in list"
                            :key="index"
                            > -->
                            <li
                            v-for="(item, index) in list"
                            :key="index"
                            >
                            <img v-if="item.icon" :src="apiUrl +'/'+item.icon" @click.stop="goPage(item)"/>
                            <!-- <img v-if="item.icon" :src="item.icon" @click.stop="goPage(item)"/> -->
                            <span v-else @click.stop></span>
                            <p v-if="item.authName" @click.stop="goPage(item)">{{ item.authName }}</p>
                            <p class="none" v-else></p>
                        </li>
                    </ul>
                </div>
            </el-carousel-item>
        </el-carousel>
        <img src="">
        <span class="el-icon-close" @click.stop="goPrevPage"></span>
    </div>
</div>
</template>

<script>
    import { serverUrl, apiUrl} from '@/utils/request';
import { data } from 'jquery';
    let childWindow = null;
    export default {
        data() {
            return {
                apiUrl,
                serverUrl:serverUrl,
                isLogin:false,
                iconlist: [
                {
                    id: "102",
                    // authName: "我的数据",
                    authName: this.$t('workPlat.txt1'),
                    path: "/myDoc",
                    icon: require('@/assets/picture/icon/nava81.png'),
                    icon1: require('@/assets/picture/icon/nava82.png'),
                    permission: '/myDoc',
                    children: [
                    {
                        id: "1011",
                        // authName: "我的文件",
                        authName: this.$t('workPlat.txt2'),
                        path: "myDoc",
                        permission: '/myDoc',
                    },
                    {
                        id: "1012",
                        // authName: "我的分享",
                        authName: this.$t('workPlat.txt3'),
                        path: "myShare",
                        permission: '/myShare',
                    },
                    {
                        id: "1013",
                        // authName: "接收分享",
                        authName: this.$t('workPlat.txt4'),
                        path: "receiveShare",
                        permission: '/receiveShare',
                    }
                    ]
                },
                {
                    id: "103",
                    // authName: "我的项目",
                    authName: this.$t('workPlat.txt5'),
                    path: "/managementProject?type=1",
                    icon: require('@/assets/picture/icon/nava3.png'),
                    icon1: require('@/assets/picture/icon/nava32.png'),
                    permission: '/managementProject',
                    children: [
                    {
                        id: "1011",
                        // authName: "管理的项目"
                        authName: this.$t('workPlat.txt6'),
                        path: "managementProject?type=1",
                        permission: '/managementProject',
                    },
                    {
                        id: "1012",
                        // authName: "参与的项目"
                        authName: this.$t('workPlat.txt7'),
                        path: "joinProject?type=2",
                        permission: '/joinProject',
                    },
                    {
                        id: "1013",
                        // authName: "审批管理",
                        authName: this.$t('workPlat.txt8'),
                        path: "aduitProject",
                        permission: '/aduitProject',
                    }
                    ]
                },
                {
                    id: "104",
                    // authName: "用户管理",
                    authName: this.$t('workPlat.txt9'),
                    path: "/userList",
                    icon: require('@/assets/picture/icon/nava4.png'),
                    icon1: require('@/assets/picture/icon/nava42.png'),
                    permission: '/userList',
                    children: [
                    {
                        id: "1011",
                        // authName: "用户管理",
                        authName: this.$t('workPlat.txt9'),
                        path: "userList",
                        permission: '/userList',
                    },
                    ]
                },
                {
                    id: "105",
                    // authName: "资源管理",
                    authName: this.$t('workPlat.txt10'),
                    path: "/desktopDot",
                    icon: require('@/assets/picture/icon/nava5.png'),
                    icon1: require('@/assets/picture/icon/nava52.png'),
                    permission: '/desktopDot',
                    children: [
                    {
                        id: "1011",
                        // authName: "桌面节点",
                        authName: this.$t('workPlat.txt11'),
                        path: "desktopDot",
                        permission: '/desktopDot',
                    },
                    {
                        id: "1012",
                        // authName: "计算节点",
                        authName: this.$t('workPlat.txt12'),
                        path: "calculateDot",
                        permission: '/calculateDot',
                    },
                    {
                        id: "1013",
                        // authName: "队列管理",
                        authName: this.$t('workPlat.txt13'),
                        path: "calculateDot",
                        permission: '/calculateDot',
                    },
                    {
                        id: "1013",
                        // authName: "作业管理",
                        authName: this.$t('workPlat.txt14'),
                        path: "taskManangement",
                        permission: '/taskManangement',
                    }
                    ]
                },
                {
                    id: "106",
                    // authName: "平台监控",
                    authName: this.$t('workPlat.txt15'),
                    path: "/platformMonitoring",
                    icon: require('@/assets/picture/icon/nava6.png'),
                    icon1: require('@/assets/picture/icon/nava62.png'),
                    permission: '/platformMonitoring',
                    children: [
                    {
                        id: "1011",
                        // authName: "集群监控",
                        authName: this.$t('workPlat.txt16'),
                        path: "platformMonitoring",
                        permission: '/platformMonitoring',
                    },
                    ]
                },
                {
                    id: "107",
                    // authName: "应用管理",
                    authName: this.$t('workPlat.txt17'),
                    path: "/applicationList",
                    icon: require('@/assets/picture/icon/nava7.png'),
                    icon1: require('@/assets/picture/icon/nava72.png'),
                    permission: '/applicationList',
                    children: [
                    {
                        id: "1011",
                        // authName: "应用管理",
                        authName: this.$t('workPlat.txt17'),
                        path: "applicationList",
                        permission: '/applicationList',
                    },
                    ]
                },
                ],
            };
        },
        watch: {
            $route() {
                let routeName = this.$route.path;
            // this.menuslist.map(e=>{
            //   if(routeName == e.path){
            //     this.children = e.children;
            //   }
            // })
        },
    },
    computed: {
        originUserMenus() {
            return this.$store.state.originUserMenus
        },
        realMenuLists() {
            let list = [];
            let { originUserMenus } = this;
            originUserMenus.forEach(item => {
                if(item.parentId === null) {
                    list.push({
                        authName: item.menuName,
                        icon: item.menuIcon,
                        path: item.menuUrl,
                        menuType: item.menuType
                    })
                }
            })
            if(list.length < 15) {
                addNoneItems(list)
                return [list]
            }
            else {
                let res = [];
                while(list.length) {
                    res.push(list.splice(0,15))
                }
                if(res[res.length - 1].length < 15) {
                    addNoneItems(res[res.length - 1])
                }
                return res
            }
            function addNoneItems(list) {
                for(let i = list.length; i < 15; i++){
                    list.push({
                        authName: '',
                        icon: '',
                        path: '',
                        menuType: ''
                    })
                }
            }
        }
    },
    // 渲染前获取数据
    created() {
        let length = this.iconlist.length;
        if (length < 15) {
            for (let i = 0; i < 15 - length; i++) {
                this.iconlist.push({});
            }
        }
        this.isLogin = this.$route.query.isLogin || false;
    },
    methods: {
        handleClick(e) {
            if(this.isLogin){
                this.$router.push("/myDoc");
            }else{
            this.$router.back()
            }
        },
        // 在新标签页打开子页面
        openChild (url) {
            childWindow = window.open(url, "_blank")        
        },
        // 父页面发送消息
        async sendMessage(){
            if (childWindow) {
                var loginName = window.sessionStorage.getItem("loginName");
				var password = window.sessionStorage.getItem("puuid"); //密码
                console.log(loginName+","+password)                
                childWindow.postMessage({ type: "from_parent_code", data: {loginName:loginName,password:password} },"*")
            }
        },
        // 父页面接收子页面的消息
        handleMessage(event){
            if (event.data?.type === "from_child_code") {
                console.log("父页面接收到子页面消息：", event.data)
                //子页面加载页面完成后发送信息
                this.sendMessage();
            }
        },
        goPage(item) {
            if(!item.path) {
                return 
            }
            if(item.menuType == 1) {
                this.$router.push(item.path);
            }
            else if(item.menuType == 3) {
                window.open(apiUrl + item.path + '?Authorization=' + localStorage.token);
                // window.location.href=apiUrl + item.path + '?Authorization=' + localStorage.token;
                // window.close();
            }
            else {
                // window.location.href=apiUrl + '/thirdparty/jumpNode?Authorization=' + localStorage.token + '&url=' + item.path;
                // window.close();
                // window.open(item.path + `?loginName=${localStorage.loginName}&password=${localStorage.password}&t=${Date.now()}`)
                if(item.path.endsWith("type=1")){ //不显示url的账号密码
                    this.openChild(item.path)
                }else{
                    window.open(apiUrl + '/thirdparty/jumpNode?Authorization=' + localStorage.token + '&url=' + item.path)
                }                
            }
        },
        goPrevPage(){
            if(this.isLogin){
                this.$router.push("/myDoc");
            }else{
            this.$router.back()
            }
        }
    },
    mounted() {
        // 组件挂载完成后执行的代码
        console.log('组件已挂载到DOM上')
        window.addEventListener("message", this.handleMessage)
    },
    destroyed() {
        console.log('组件已销毁（完全卸载）')
        // 此时组件相关资源已释放
        window.removeEventListener("message", this.handleMessage)
    }
};
</script>

<style lang="less" scoped>
    .bg {
        width: 100%;
        height: 100%;
        background-image: url("../../assets/picture/-s-bg_img.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
    .el-icon-close{
        position: absolute;
        right: 50%;
        bottom: 77px;
        margin-right: -18px;
        font-size: 40px;;
        cursor: pointer;
        color: #fff;
        z-index: 2;
    }
    .workPlatPage {
        width: 80%;
        height: 80%;
        background: #ffffff82;
        padding: 8rem 8rem;
        border-radius: 10rem;
        position: fixed;
        top: 50%;
        left: 50%;
        overflow: hidden;
        transform: translate(-50%, -50%);
        /deep/ .el-carousel--horizontal,
        /deep/ .el-carousel__container {
            width: 100%;
            height: 100% !important;
        }
        .el-icon-close{
            color: #1B3B7C;
            font-weight: bold;
        }
        ul {
            overflow: hidden;
            display: flex;
            flex-wrap: wrap;
        }
        li {
            width: 20%;
            margin-bottom: 1.9rem;
            span,
            img {
                display: block;
                width: 8.5vh;
                height: 8.5vh;
                margin: 0 auto 1rem;
                border-radius: 2rem;
                cursor: pointer;
            }
        }
        li:nth-child(5n) {
            margin-right: 0;
        }
        p {
            display: inline-block;
            font-size: 1.4rem;
            font-weight: 600;
            line-height: 2.2rem;
            cursor: pointer;
            font-weight: 500;
            color: #222222;
        }
        .none {
            color: #7f7f7f;
        }
        .workPlatPageBox {
            width:100%;
            text-align: center;
        }
        /deep/ .el-carousel__indicators--horizontal {
            bottom: 10rem;
            display: none;
        }
        /deep/ .el-carousel__button {
            width: 3.6rem;
            height: 0.6rem;
            background: #ffffff;
            border-radius: 1rem;
        }
    }
</style>